import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Link2, CheckCircle2 } from "lucide-react";

const SurveillanceVmsScreen: React.FC = () => {
  const navigate = useNavigate();

  const capabilities = [
    "Ingest camera registry and optional stream / playback URLs from your VMS export or middleware.",
    "Push motion and analytics events to the authenticated motion-alerts API (server-to-server).",
    "Sync operational status: map VMS device health to camera health checks in this module.",
    "Link exported clip URLs to incidents via incident video tagging (metadata + URL).",
    "Use Security integrations for outbound webhooks and cross-system incident sync where enabled.",
  ];

  return (
    <div className="px-2 py-4 mt-14 min-h-screen space-y-6 max-w-3xl">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => navigate("/security/surveillance")}
          className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="w-4 h-4" />
          Overview
        </button>
        <div className="bg-[#EAFBFA] p-3 rounded-lg">
          <Link2 className="w-6 h-6 text-[#0fa9a6]" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-gray-900">VMS integration</h2>
          <p className="text-sm text-gray-600">
            Patterns for connecting enterprise video management without embedding vendor URLs in the
            UI.
          </p>
        </div>
      </div>

      <ul className="space-y-3">
        {capabilities.map((text) => (
          <li
            key={text}
            className="flex gap-3 items-start bg-white border border-gray-100 rounded-lg p-4 shadow-sm"
          >
            <CheckCircle2 className="w-5 h-5 text-[#0fa9a6] shrink-0 mt-0.5" />
            <span className="text-sm text-gray-700 leading-relaxed">{text}</span>
          </li>
        ))}
      </ul>

      <p className="text-xs text-gray-500">
        Configure stream endpoints in Camera master per device. For HLS or proprietary protocols,
        terminate at a gateway your browser can play (e.g. MP4 or HLS) or embed your vendor&apos;s
        signed player in a dedicated integration layer.
      </p>
    </div>
  );
};

export default SurveillanceVmsScreen;
